import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './ServiceSelectionView.html?raw';
// NOTE (JS2TS): original define() also listed dojo/dijit deps never referenced in code and not
// used via data-dojo-type (connect, array, Color, keys, registry, on, dom-attr, dom-class,
// dom-construct) — dead, dropped. Tabulator is a runtime-provided global (typed via
// @types/tabulator-tables).

class ServiceSelectionView extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    _data: any = [];

    add(entity: any): void {
        console.log("ServiceSelectionView - add", entity);

        for (var i = 0; i < this._data.length; i++) {
            var rowData = this._data[i];
            if (rowData.ID == entity.ID) {
                if ((entity.is_quantity_selectable == true || entity.is_quantity_selectable == 1) && rowData.quantity < entity.quantity_max) {
                    rowData.quantity = rowData.quantity + 1;
                }
                return; // duplikat
            }
        }

        //  Quantitiy für neu hinzugefügte zeilen auf 1 setzen
        //
        if (typeof (entity.quantity) == "undefined") {
            entity.quantity = 1;
        }

        this._data.push(entity);

        this.emit("change", this._data);
    }

    getData(): any {
        return this._data;
    }

    clear(): void {
        this._data = [];
        this.renderView();
    }

    _getSelectionAttr(): any {
        return this._data;
    }

    _getSelectedServicesAttr(): any {
        var services = [];

        for (var i = 0; i < this._data.length; i++) {
            var entity = this._data[i];

            services.push(entity.ID);
        }

        return services;
    }

    _getSelectedServicesQuantityAttr(): any {
        var services = {};

        for (var i = 0; i < this._data.length; i++) {
            var entity = this._data[i];

            services[entity.ID] = Number(entity.quantity);
        }

        return services;
    }

    renderView(): void {

        var tableObj = new Tabulator(this.tableNode, {
            data: this._data,
            //height: "311px",
            responsiveLayout: "collapse",
            responsiveLayoutCollapseStartOpen: false,
            columns: [
                { title: "icon", field: "tmp_icon_base64", width: 50, headerSort: false, formatter: lang.hitch(this, "iconFormatter") },
                { title: "item", formatter: lang.hitch(this, "_formatterDescription" ), field: "description_D", headerSort: false },
                { title: "quantity", field: "quantity", headerSort: false, editor: lang.hitch(this, "quantityEditor") },
                {
                    title: "delete",
                    formatter: "buttonCross",
                    cellClick: lang.hitch(this, "_onClick_DeleteItem"),
                    headerSort: false
                }
            ],
            rowFormatter: function (row) {
                row.getElement().style.height = "60px";
            }
        } as any);

        domStyle.set(this.tableNode, "background", "unset");

    }

    _formatterDescription(cell: any, formatterParams: any): any {
        var data = cell.getData();

        if (data.ev_service_text_booking) {
            return cell.getValue() + "<br/><div style=\"font-size: 12px; color: gray; font-style: italic;\">" + data.ev_service_text_booking + "</div>";
        }

        return cell.getValue();
    }

    _onClick_DeleteItem(e: any, cell: any): void {
        cell._cell.row["delete"]();

        var newData = [];
        for (var i = 0; i < this._data.length; i++) {
            var rowData = this._data[i];

            if (rowData != cell._cell.row.data) {
                newData.push(rowData);
            }
        }

        this._data = newData;
        this.renderView();

        this.emit("change", this._data);
    }

    iconFormatter(cell: any, formatterParams: any, onRendered: any): any {
        if (cell._cell) {
            var iconData = cell._cell.row.data.tmp_icon_base64;
            if (!iconData) {
                iconData = cell._cell.row.data.service_ev_serv___tmp_icon_base64;
            }

            var iconTag = "<img src=\"" + iconData + "\" style=\"margin-right: 4px; height: 40px;\" />";
            return iconTag;
        }
        return "";
    }

    quantityEditor(cell: any, onRendered: any, success: any, cancel: any): any {
        //cell - the cell component for the editable cell
        //onRendered - function to call when the editor has been rendered
        //success - function to call to pass the successfuly updated value to Tabulator
        //cancel - function to call to abort the edit and return to a normal cell

        if (cell._cell.row.data.is_quantity_selectable != 1 && cell._cell.row.data.is_quantity_selectable != true) {
            cancel();
            return;
        }

        var quantity_max = Number(cell._cell.row.data.quantity_max);

        //create and style input
        var cellValue = cell.getValue(),
            input: any = document.createElement("input");

        input.setAttribute("type", "number");

        input.style.padding = "4px";
        input.style.width = "100%";
        input.style.boxSizing = "border-box";
        input.max = quantity_max;
        input.min = 0;

        input.value = cellValue;

        onRendered(function () {
            input.focus();
            input.style.height = "100%";
        });

        // JS2TS: `onChange` is assigned without `var` in the original — a leaked implicit global
        // (window.onChange). Preserved verbatim as (window as any).onChange (not a class member).
        (window as any).onChange = lang.hitch(this, function () {
            if (Number(input.value) < 0) { // negativ geht nie
                input.value = 1;
                success(input.value);
                this.emit("change", this._data);
                return;
            }

            if (quantity_max > 0) { // falls max definiert, dann range prüfen
                if (Number(input.value) <= quantity_max) {
                    success(input.value);
                    this.emit("change", this._data);
                } else {
                    input.value = quantity_max;
                    success(input.value);
                    this.emit("change", this._data);
                }
                return;
            }

            if (input.value != cellValue) {
                success(input.value);
                this.emit("change", this._data);
            } else {
                cancel();
                this.emit("change", this._data);
            }
        });

        //submit new value on blur or change
        input.addEventListener("blur", (window as any).onChange);

        //submit new value on enter
        input.addEventListener("keydown", function (e) {

            if (e.keyCode == 13) {
                (window as any).onChange();
            }

            if (e.keyCode == 27) {
                cancel();
            }
        });

        return input;
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

        this._data = [];
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);

    }
}
ServiceSelectionView.prototype.declaredClass = 'more.Legacy.Zal.ServiceSelectionView';

export default mdsWidget(ServiceSelectionView);
